import React, { useState } from "react";
import { MdOutlineCancel } from "react-icons/md";
import useEducationalActivities from "../../../hooks/useEducationalActivities";
import { useUIContext } from "../../../context/UIContext";
import HelpHyperLink from "../../../unicomponents/HelpHyperLink";
import {
  calculateTextNumber,
  calculateTextNumberByte,
} from "../../../util/etCetera";
import DropdownUniqueUsersInDisplayData from "../../../unicomponents/Dropdowns/DropdownUniqueUsersInDisplayData";
import { useAuthContext } from "../../../context/AuthContext";
import { useTranslation } from "react-i18next";

export default function AddClubActivity({
  conditions,
  schoolYearId,
  schoolStageId,
  user,
  tagList,
  userData,
  activeMenu,
}) {
  const { t } = useTranslation();

  const optionCategory =
    activeMenu?.options?.[0]?.[activeMenu?.schoolid]?.category || "";

  const optionEndDate =
    activeMenu?.options?.[0]?.[activeMenu?.schoolid]?.end_date || "";

  const [formData, setFormData] = useState({
    schoolid: conditions.schoolid,
    school_year_id: schoolYearId,
    hierarchy_one: "",
    title: "",
    content: "",
    start_date: "",
    creator_username: user?.username,
    activity_type_id: 4,
    extra_attributes: {
      hours: "",
      textLength: "",
      category: optionCategory[0] || "",
    },
    tags: [],
  });
  //submit 누르면 로딩 뜨도록
  const { setIsLoadingModal, handleToastCenterTop } = useUIContext();
  const { hasPermission } = useAuthContext();

  //submit를 위한
  const { createEducationalActivities } = useEducationalActivities(conditions);

  const [tag, setTag] = useState("");
  const [isSaved, setIsSaved] = useState(false);

  const handleInputChange = (event) => {
    const { name, value, id } = event.target;

    if (name === "extra_attributes") {
      setFormData((formData) => ({
        ...formData,
        [name]: {
          ...formData[name],
          [id]: value,
        },
      }));
    } else if (name === "tags") {
      setTag(value);
      const newTag = { [value]: "3" };
      const isTagSelected = formData.tags.some((tag) =>
        tag.hasOwnProperty(value),
      );
      if (!isTagSelected && value !== "") {
        setFormData((formData) => ({
          ...formData,
          tags: [...formData.tags, newTag], // 새 태그 객체를 배열에 추가
        }));
      }
    } else {
      setFormData((formData) => ({
        ...formData,
        [name]: value,
      }));

      if (name === "content") {
        setFormData((formData) => ({
          ...formData,
          textLength: calculateTextNumber(value),
          textLengthByte: calculateTextNumberByte(value),
        }));
      }
    }

    // console.log("handle Input formData", formData);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    // Process the formData here

    const submitData = {
      ...formData,
      school_year_id: schoolYearId,
      hierarchy_one: schoolStageId,
    };

    if (!submitData.hierarchy_one) {
      handleToastCenterTop(t("common.messages.selectCourse"));
      return;
    }

    // console.log("submitData", submitData);
    if (!hasPermission(submitData?.creator_username, "can_create")) {
      handleToastCenterTop(
        t("common.messages.ownerPermission") ||
          "본인 것 외 생성은 권한이 있는 사람만 생성할 수 있습니다.",
      );
      return;
    }

    setIsLoadingModal(true);
    createEducationalActivities.mutate(submitData, {
      onSuccess: () => {
        // console.log("formData2", submitData);
        //이제 여기서 서버로 보내면 됨

        setIsLoadingModal(false);
        setIsSaved(true);
        setTimeout(() => {
          setIsSaved(false);
        }, 2000);
      },
      onError: (error) => {
        setIsLoadingModal(false);
        console.error(error); // 일단 콘솔에 에러를 출력합니다.
        console.error("위와 같은 에러가 났으니 고치삼");
        alert(t("common.messages.errorAlert") + error?.message);
      },
    });
  };

  const handleClick = (tagKey) => {
    setFormData((formData) => ({
      ...formData,
      tags: formData.tags.filter((tag) => !tag.hasOwnProperty(tagKey)),
    }));
  };

  return (
    <form onSubmit={handleSubmit} className="container-fluid">
      <h3 className="fw-bold">
        {t("teacher.createActivities.createClubTitle")}{" "}
        <HelpHyperLink link={"https://youtu.be/_M6NElcaTKk"} />
      </h3>
      <table
        className="table"
        style={
          activeMenu?.options?.length > 0 &&
          activeMenu?.options[0]?.[conditions.schoolid]
            ? { fontSize: "smaller" }
            : {}
        }
      >
        <thead>
          <tr className="table-secondary">
            {optionCategory && (
              <th style={{ width: "90px" }}>{t("common.labels.category")}</th>
            )}
            <th style={{ minWidth: "80px", width: "220px" }}>
              {t("common.labels.activityName")}
            </th>
            <th style={{ width: "105px" }}>{t("common.labels.startDate")}</th>
            {optionEndDate && (
              <th style={{ width: "105px" }}>{t("common.labels.endDate")}</th>
            )}
            <th style={{ minWidth: "60px", width: "65px" }}>
              {t("common.labels.hours") || "시간"}
            </th>
            <th style={{ minWidth: "150px" }}>
              {t("common.labels.specialNote")} ({t("common.labels.textLength")}:{" "}
              {formData.textLength}/{formData.textLengthByte} )
            </th>
            <th style={{ width: "80px" }}>
              {t("teacher.createActivities.activityCreator")}
            </th>
            <th style={{ minWidth: "50px", width: "85px" }}>
              {t("common.labels.selectTag")}
            </th>
            <th style={{ width: "120px" }}>{t("common.labels.tag")}</th>
            <th style={{ width: "60px" }}>
              {t("common.labels.add") || "추가"}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            {optionCategory && (
              <td>
                <select
                  className="select-like-span"
                  name="extra_attributes"
                  id="category"
                  value={formData.extra_attributes?.category}
                  onChange={handleInputChange}
                >
                  {optionCategory &&
                    optionCategory.map((option, index) => (
                      <option key={index} value={option}>
                        {option}
                      </option>
                    ))}
                </select>
              </td>
            )}
            <td className="p-0">
              <textarea
                type="text"
                className="input-like-span"
                name="title"
                value={formData.title}
                onChange={handleInputChange}
                rows={4}
                required
              />
            </td>
            <td>
              <input
                type="date"
                className="input-like-span"
                name="start_date"
                value={formData.start_date}
                onChange={handleInputChange}
                required
                style={{ width: "105px" }}
              />
            </td>
            {optionEndDate && (
              <td>
                <input
                  type="date"
                  className="input-like-span"
                  name="extra_attributes"
                  id="end_date"
                  value={formData.extra_attributes?.end_date}
                  onChange={handleInputChange}
                  style={{ width: "105px" }}
                />
              </td>
            )}
            <td>
              <input
                type="number"
                className="input-like-span"
                name="extra_attributes"
                id="hours"
                value={formData.extra_attributes?.hours}
                onChange={handleInputChange}
                required
              />
            </td>

            <td className="p-0">
              <textarea
                type="text"
                className="input-like-span"
                name="content"
                value={formData.content}
                onChange={handleInputChange}
                rows={4}
              />
            </td>
            <td width={90}>
              <DropdownUniqueUsersInDisplayData
                displayData={userData}
                displayKey={"fullname"}
                valueKey={"username"}
                uniqueKey={"username"}
                sortKey={"fullname"}
                isDesc={false}
                handleDropdownChange={handleInputChange}
                selectedUser={formData.creator_username}
                selectName={"creator_username"}
                styleClass={"select-like-span"}
                dropdownTitle={t("common.user.teacher") || "교사"}
                required={true}
              />
            </td>
            <td>
              <select
                className="select-like-span"
                name="tags"
                value={tag}
                onChange={handleInputChange}
              >
                <option value="">{t("common.labels.select") || "선택"}</option>
                {tagList &&
                  tagList[0]?.tags.map((tag, index) => (
                    <option key={index} value={tag}>
                      {tag}
                    </option>
                  ))}
              </select>
            </td>
            <td width={128}>
              {formData.tags.map((tagObj, index) => {
                const [tagKey] = Object.keys(tagObj); // 객체에서 키 추출
                return (
                  <span key={index}>
                    {tagKey}
                    <MdOutlineCancel
                      role="button"
                      onClick={() => {
                        handleClick(tagKey); // 태그 삭제 함수 호출
                      }}
                    />
                  </span>
                );
              })}
            </td>
            <td width={60} rowSpan={2} valign="middle">
              <button type="submit" className="btn btn-sm p-1 btn-primary">
                {isSaved
                  ? t("common.labels.complete") || "완료"
                  : t("common.labels.add") || "추가"}
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </form>
  );
}
